import type { StoreDetailsFeatureFlagClient } from '../../../../types/features/storeDetails/featureFlags';
import { STORE_DETAILS_FEATURE_FLAGS_CLIENT_PARAM } from '../../utils/storeDetailsQueryParams';

export const DEFAULT_STORE_DETAILS_FEATURE_FLAGS_CLIENT: StoreDetailsFeatureFlagClient = 'webapp';

export const isStoreDetailsFeatureFlagClient = (
  value: string | null,
): value is StoreDetailsFeatureFlagClient => value === 'webapp' || value === 'mobile_app';

export const getStoreDetailsFeatureFlagClientFromSearchParams = (
  searchParams: URLSearchParams,
): StoreDetailsFeatureFlagClient => {
  const clientParam = searchParams.get(STORE_DETAILS_FEATURE_FLAGS_CLIENT_PARAM);

  return isStoreDetailsFeatureFlagClient(clientParam)
    ? clientParam
    : DEFAULT_STORE_DETAILS_FEATURE_FLAGS_CLIENT;
};

export const buildStoreDetailsFeatureFlagClientSearchParams = (
  searchParams: URLSearchParams,
  client: StoreDetailsFeatureFlagClient,
): URLSearchParams => {
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.set(STORE_DETAILS_FEATURE_FLAGS_CLIENT_PARAM, client);
  return nextSearchParams;
};
